import { api } from './client';
import type { OneCConnection, SyncLogEntry, FocusResult, Paginated } from '@/types';

export const integrationsApi = {
  async connections(): Promise<OneCConnection[]> {
    const { data } = await api.get<Paginated<OneCConnection>>('/1c-connections/');
    return data.results ?? (data as unknown as OneCConnection[]);
  },
  async saveConnection(payload: Partial<OneCConnection> & { ws_password?: string }): Promise<OneCConnection> {
    if (payload.id) {
      const { data } = await api.patch<OneCConnection>(`/1c-connections/${payload.id}/`, payload);
      return data;
    }
    const { data } = await api.post<OneCConnection>('/1c-connections/', payload);
    return data;
  },
  async sync(id: number): Promise<{ detail: string }> {
    const { data } = await api.post(`/1c-connections/${id}/sync/`);
    return data;
  },
  async syncLog(): Promise<SyncLogEntry[]> {
    const { data } = await api.get<Paginated<SyncLogEntry>>('/sync-log/');
    return data.results ?? (data as unknown as SyncLogEntry[]);
  },
  async focusVerify(inn: string): Promise<FocusResult> {
    const { data } = await api.get<FocusResult>('/integrations/focus-verify/', { params: { inn } });
    return data;
  },
};

// Экспорт в Excel (скачивание blob)
async function downloadXlsx(url: string, filename: string) {
  const { data } = await api.get(url, { responseType: 'blob' });
  const blobUrl = URL.createObjectURL(data as Blob);
  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(blobUrl), 30_000);
}

export const exportApi = {
  contracts: () => downloadXlsx('/exports/contracts/', 'Реестр_договоров.xlsx'),
  ks2: () => downloadXlsx('/exports/ks2/', 'Реестр_КС-2.xlsx'),
  estimate: (id: number, number: string) => downloadXlsx(`/exports/estimate/${id}/`, `Смета_${number}.xlsx`),
};
